<template>
  <div>
    <div class="text-xl font-bold text-text leading-tight mb-8">{{ $t('listTitle') }}</div>
    <template v-if="list.length > 0">
      <draggable :value="list"
                 handle=".handle"
                 :group="{ name: 'items' }"
                 @input="sortedList = $event">
        <div v-for="(item,j) in sortedList" :key="j"
             class="flex items-center rounded pl-4 pr-4 py-4
                        bg-block hover:bg-bg group
                        transition duration-200">
          <MKIcons :icon="item.icon" class="text-icon mr-6 w-10 h-10 -my-2 text-md"/>
          <div class="text-text-secondary text-sm mr-auto -ml-0-5">{{ item.title }}</div>
          <div class="mr-16 flex items-center space-x-4">
            <IconArrowDownSquare v-if="item.is_default"
                                 class="text-icon-info -my-2"
                                 v-tooltip="$t('tooltipIsDefault')"/>
          </div>
          <template v-if="!currentUserIsWatcher">
            <div class="mr-4" @click="$emit('editIncome',item)">
              <IconEdit class="opacity-0 group-hover:opacity-100
                                 transition duration-200 cursor-pointer
                                 text-icon hover:text-icon-hover"/>
            </div>
            <div class="handle">
              <IconMove class="transition duration-200 cursor-pointer text-icon hover:text-icon-hover"/>
            </div>
          </template>
        </div>
      </draggable>
    </template>
    <div v-else class="text-md pl-2 text-text">
      {{ $t('noIncomeSources') }}
    </div>
  </div>

</template>

<script>
import draggable from 'vuedraggable';
import IconEdit from "@/components/icons/IconEdit";
import IconMove from "@/components/icons/IconMove";
import {mapActions, mapGetters} from "vuex";
import MKIcons from "@/components/icons/MKIcons/MKIcons";
import IconArrowDownSquare from "@/components/icons/IconArrowDownSquare";

export default {
  name: "IncomeList",
  components: {IconArrowDownSquare, MKIcons, IconMove, IconEdit, draggable},
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher']),
    sortedList: {
      get() {
        return this.list
      },
      set(list) {
        let incomesOrderedList = list.map((item, order) => ({...item, order}));
        this.$store.dispatch('space/incomes/updateIncomeSourcesOrders', incomesOrderedList)
      }
    }
  },
  i18n: {
    messages: {
      en: {
        listTitle: 'Income sources list',
        noIncomeSources: 'You haven\'t created any income source',
        tooltipIsDefault: 'Default source of income for imported transactions'
      },
      ru: {
        listTitle: 'Список источников дохода',
        noIncomeSources: 'У вас еще нет источников дохода',
        tooltipIsDefault: 'Источник дохода по умолчанию для импортируемых транзакций'
      }
    }
  }
}
</script>
